<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="专链名称：" prop="name">
                <el-input v-model="filterForm.name" placeholder="请输入名称搜索"></el-input>
              </el-form-item>
              <el-form-item label="关联代理商：" prop="agentId">
                <el-select filterable v-model="filterForm.agentId" placeholder="请选择">
                  <el-option v-for="item in agentOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="有效期：" prop="time" class="auto-width">
                <el-date-picker v-model="filterForm.time" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH时"
                  value-format="yyyy-MM-dd HH:00:00" :default-time="['00:00:00', '23:59:59']"
                  popper-class="hour-only-picker" :append-to-body="false">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <el-button class="btn-add-block" type="primary" @click="pageNavigateToAdd">新建专链</el-button>

        <!-- table -->
        <list-table :table-data="tableData" :columns="tableColumns" :table-loading="tableLoading"
          :actions="tableActions" @action="handleAction" />

        <div class="table-footer" v-if="page.total > 0">
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

<!-- 代理商专链弹窗 (新增/编辑) -->
<add-dialog :visible.sync="dialogVisible" :dialog-mode="dialogMode" :row-data="currentRow" @success="getList" />
<!-- 代理商专链弹窗 (详情) -->
<detail-dialog :visible.sync="detailVisible" :row-data="currentRow" />
      </section>
</template>

<script>
import ListTable from './components/listTable.vue'
import AddDialog from './components/addDialog.vue'
import DetailDialog from './components/detailDialog.vue'
import {
  commodityLinkList,
  agentCompanylistAll,
  commodityAgentUpdateById
} from '@/common/api'

export default {
  name: 'goodsLinkList',
  components: {
    ListTable,
    AddDialog,
    DetailDialog
  },
  data() {
    return {
      filterForm: {
        name: '',
        agentId: '',
        time: []
      },
      agentOptions: [],
      tableLoading: false,
      dialogVisible: false,
      dialogMode: 'add',
      detailVisible: false,
      currentRow: null,
      tableData: [],
      page: {
        current: 1,
        size: 20,
        total: 0
      },
      tableColumns: [
        { label: '专链编码', prop: 'code', minWidth: '100' },
        { label: '专链名称', prop: 'name', minWidth: '160', showOverflowTooltip: true },
        { label: '商品', prop: 'goodsName', minWidth: '160', showOverflowTooltip: true },
        { label: '折扣力度', prop: 'discount', minWidth: '100' },
        { label: '专链链接', prop: 'link', minWidth: '160', showOverflowTooltip: true },
        { label: '关联代理商', prop: 'agentName', minWidth: '120' },
        { label: '已销售数量', prop: 'sumCommodityCount', minWidth: '100' },
        { label: '有效期', prop: 'validTime', minWidth: '160' },
        { label: '状态', prop: 'status', minWidth: '80' }
      ],
      tableActions: [
        { label: '详情', value: 'detail' },
        { label: '编辑', value: 'edit', show: row => row.status !== '已过期' },
        { label: '取消', value: 'cancel', show: row => row.status === '待生效' },
        { label: '暂停', value: 'suspend', show: row => row.status === '生效中' }
      ],
      dialogMode: 'add',
      currentRow: null
    }
  },
  methods: {
    getAgentList() {
      agentCompanylistAll().then(res => {
        if (res.code === 0 && res.data) {
          this.agentOptions = (res.data || [])
        } else {
          this.agentOptions = []
        }
      }).catch(err => {
        console.error('获取代理商列表失败:', err)
        this.agentOptions = []
      })
    },
    getList() {
      // 获取商品专链列表逻辑
      this.tableLoading = true;
      commodityLinkList({
        pageNum: this.page.current,
        pageSize: this.page.size,
        name: this.filterForm.name,
        agentId: this.filterForm.agentId,
        startTime: this.filterForm.time ? this.filterForm.time[0] : '',
        endTime: this.filterForm.time ? this.filterForm.time[1] : ''
      }).then(res => {
        if (res.code === 0 && res.data) {
          this.tableData = (res.data.records || []).map(item => {
            let discount = '';
            if (item.discountType === 1) {
              discount = `立减${item.discountValue}元`;
            } else if (item.discountType === 2) {
              discount = `${item.discountValue / 10}折`;
            } else if (item.discountType === 3) {
              discount = `售价${item.discountValue}元`;
            }
            return {
              ...item,
              code: item.id || '-',
              name: item.name || '-',
              // type: item.type === 1 ? '全产品' : '单产品',
              goodsName: item.commodityName || '/',
              discount: discount,
              link: item.url || '-',
              agentName: item.agentName || '/',
              salesCount: item.sumcommodityCount || 0,
              validTime: this.formatValidTime(item.startTime, item.endTime),
              status: this.getStatus(item.startTime, item.endTime, item.state)
            };
          });
          this.page.total = res.data.total || 0;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      }).catch(err => {
        console.error('获取商品专链列表失败:', err);
        this.tableData = [];
        this.page.total = 0;
      }).finally(() => {
        this.tableLoading = false;
      })
    },
    getStatus(startStr, endStr, state) {
      if (!startStr || !endStr) return '未知';
      const now = new Date().getTime();
      // 兼容 Safari 的日期解析，将 - 替换为 /
      const start = new Date(startStr.replace(/-/g, '/')).getTime();
      const end = new Date(endStr.replace(/-/g, '/')).getTime();
      if (state === 2) return '已取消';
      if (now < start) return '待生效';
      if (now > end) return '已过期';
      return '生效中';
    },
    formatValidTime(startStr, endStr) {
      if (!startStr || !endStr) return '';
      const format = (str) => str.substring(0, 13).replace(/-/g, '.');
      return `${format(startStr)}时-${format(endStr)}时`;
    },
    filterFormSubmit() {
      this.page.current = 1
      this.getList()
    },
    filterFormReset() {
      this.$refs['filterForm'].resetFields()
      this.page.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    pageNavigateToAdd() {
      // 新建专链弹窗展示
      this.dialogMode = 'add';
      this.currentRow = null;
      this.dialogVisible = true;
    },
    handleAction(action, row) {
      if (action === 'detail') {
        this.currentRow = row;
        this.detailVisible = true;
      } else if (action === 'edit') {
        // 编辑专链展示
        this.dialogMode = 'edit';
        this.currentRow = row;
        this.dialogVisible = true;
      } else if (action === 'cancel' || action === 'suspend') {
        this.$confirm(`确定要${action === 'cancel' ? '取消' : '暂停'}该专链吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          commodityAgentUpdateById({
            id: row.id,
            state: 2
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('取消成功');
              this.getList();
            }
          })
        }).catch(() => { });
      }
    }
  },
  mounted() {
    this.getAgentList()
    this.getList()
  }
}
</script>

<style scoped lang="scss">
.page-main {
  padding-bottom: 60px;

  .page-section {
    .filter-region {
      display: flex;
      justify-content: space-between;

      .filter-form {
        flex: 1;
      }

      .filter-btn {
        .btn-group {
          .btn-reset {
            width: 40px;
            height: 40px;
            border-color: #3388ff;
            color: #3388ff;
          }

          .btn-search {
            width: 84px;
            height: 40px;
          }
        }

      }
    }
  }
}
</style>
